import { render, staticRenderFns } from "./VacationBalanceEditModal.vue?vue&type=template&id=fb4fb6c6&scoped=true&"
import script from "./VacationBalanceEditModal.vue?vue&type=script&lang=ts&"
export * from "./VacationBalanceEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4fb6c6",
  null
  
)

export default component.exports